import * as React from 'react';
import {GoogleLogin, GoogleLoginResponse, GoogleLoginResponseOffline} from 'react-google-login';

import './Login.scss';
import {clientId} from './config/googleClientId';

export interface ILoginProps {
  onSuccess: ({accessToken}: {accessToken: string}) => void;
  onFailure: () => void;
}

export default ({onSuccess, onFailure}: ILoginProps): JSX.Element => {
  const handleGoogleLoginSuccess = (response: GoogleLoginResponse | GoogleLoginResponseOffline) => {
    if ('accessToken' in response) {
      onSuccess(response);
    }
  };

  return (
    <div className='login-container '>
      <div className='login-container__login-button'>
        <GoogleLogin
          clientId={clientId}
          buttonText='Login with Pluto account'
          onSuccess={response => handleGoogleLoginSuccess(response)}
          onFailure={() => onFailure()}
          isSignedIn
          responseType='token'
          cookiePolicy='single_host_origin'
        />
      </div>
    </div>
  );
};
